export default __webpack_public_path__ + "static/media/lg_near.a21280ce.svg";